module.exports = __webpack_public_path__ + "img/logo_new.253d57fb.png";